<!--
    @Author : Luo
    @Time   : 2025/1/17 11:32
-->
<template>
  <div class="client text_left">
    <div class="client_header">
      <div class="client_header_con">
        <div class="client_header_l"><span>调研数据</span></div>
        <div class="client_header_r flex_center">
          <div class="client_header_date">
            <input type="date" v-model="startDate" name="">
            -
            <input type="date" v-model="endDate" name="">
          </div>
          <div class="client_header_btn">
            <button type="button" @click="getUserInfo">搜索</button>
          </div>
        </div>
      </div>
    </div>
    <div class="stage_nav">
      <div class="stage_nav_con flex_center">
        <div class="stage_nav_info text_ellipsis" style="margin-left: 40px">
          <span>咨询师</span>
        </div>
        <div class="stage_nav_info text_ellipsis"><span>总数</span></div>
      </div>
    </div>
    <div class="user_main">
      <div class="user_main_con">
        <div v-for="i in userData" :key="'u-' + i.id" class="user_container">
          <div class="user_info" @click="i.hidden = !i.hidden">
            <div class="user_name" title="点击查看详情">
              <span style="color: #4C8BFF;font-size: 16px;font-weight: 400;display: inline-block;width: 40px;text-align: center" v-html="i.hidden ? '&and;' : '&or;'" />
              <span>{{ i.name }}</span>
            </div>
            <div class="user_total_val">
              <span style="color: #4C8BFF;font-size: 16px;font-weight: 400" v-html="i.totalClientNew" />
            </div>
          </div>
          <div class="user_session" v-if="i.hidden">
            <div class="user_session_con">
              <div class="user_session_header">
                <div class="user_session_header_con">
                  <div class="user_session_header_info user_session_info_time text_ellipsis"><span>时间</span></div>
                  <div class="user_session_header_info user_session_info_remark text_ellipsis"><span>备注</span></div>
                  <div class="user_session_header_info user_session_info_status text_ellipsis"><span>状态</span></div>
                  <div class="user_session_header_info user_session_info_status text_ellipsis"><span>提交时间</span></div>
                </div>
              </div>
              <div class="user_session_main">
                <div v-for="c in i.session" :key="'u-' + i.id + '-c-' + c.id" class="user_session_main_con">
                  <div :class="'user_session_main_info_con ' + (c.select ? 'user_session_main_info_select' : '')">
                    <div class="user_session_main_info user_session_info_time text_ellipsis"><span><strong>{{ setDateType(c.createdAt) }}</strong> {{ setDateSecond(c.createdAt) }}</span></div>
                    <div class="user_session_main_info user_session_info_remark text_ellipsis" :title="c.content"><span>{{ c.content }}</span></div>
                    <div class="user_session_main_info text_ellipsis">
                      <div :class="'user_session_main_info_status user_session_main_info_tag_' + getSessionStageStagusTag(c.isComplete)"><span><strong>{{ getSessionStageStagusVal(c.isComplete) }}</strong></span></div>
                    </div>
                    <div class="user_session_main_info user_session_info_time text_ellipsis"><span><strong>{{ setDateType(c.submitAt) }}</strong> {{ setDateSecond(c.submitAt) }}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { _Ajax } from '@/api/_axios'
import { setDateType, setDateSecond, setEndDate, setStartDate } from '@/components/common/common_js'

export default {
  name: 'accountAnalysisPage',
  components: {},
  data () {
    return {
      baseUrl: '',
      startDate: null,
      endDate: null,

      userData: [],

      setDateType: setDateType,
      setDateSecond: setDateSecond
    }
  },
  methods: {
    getData: async function () {
      const that = this

      try {
        await that.getUserInfo()
      } catch (error) {
        console.log('【error:getData】', error)
      }
    },
    // 获取用户信息
    getUserInfo: async function () {
      try {
        const that = this
        this.userData = []

        const tempUserData = await that.getApiData('/user/list')
        const tempClientData = await that.getApiData('/session/category')

        for (const item of tempUserData) {
          const tempUserSession = tempClientData.filter(i => i.userId === item.id)
          const tempTranslateUserSession = that.translateSession(tempUserSession)

          that.userData.push({
            ...item,
            ...tempTranslateUserSession,
            hidden: false
          })
        }
      } catch (error) {
        console.log('【error:getUserInfo】', error)
      }
    },
    // 转义数据
    translateSession: function (data) {
      const that = this
      const tempStartDate = setStartDate(that.startDate)
      const tempEndDate = setEndDate(that.endDate)

      const clientData = []
      let tempTotalClientNew = 0

      // 筛选符合条件的客户
      for (const item of data) {
        const tempDate = new Date(item.createdAt)
        const tempIsComplete = item.isComplete === 1
        const tempClientData = {
          ...item,
          select: tempIsComplete && tempStartDate && tempEndDate && tempDate >= new Date(tempStartDate).getTime() && tempDate <= new Date(tempEndDate).getTime(),
          stages: []
        }

        clientData.push(tempClientData)

        if (tempIsComplete && tempClientData.select) tempTotalClientNew++
      }

      return {
        session: clientData,
        totalClientNew: tempTotalClientNew
      }
    },
    // 获取客户阶段数据的状态
    getSessionStageStagusVal: function (status) {
      let data = ''

      switch (status) {
        case 0:
          data = '进行中'
          break
        case 1:
          data = '已完成'
          break
        default:
          data = '进行中'
          break
      }

      return data
    },
    // 获取客户阶段数据的标签颜色
    getSessionStageStagusTag: function (status) {
      let data = ''

      switch (status) {
        case 0:
          data = 'planning'
          break
        case 1:
          data = 'success'
          break
        default:
          data = 'planning'
          break
      }

      return data
    },
    getApiData: function (url) {
      const that = this
      return new Promise((resolve, reject) => {
        _Ajax({ baseUrl: that.baseUrl, method: 'get', url: url, clearCancelSource: true }, (res) => { resolve(res.data.data) }, reject)
      })
    }
  },
  mounted () {
    const that = this
    const envModule = process.env.ENV_MODULE

    that.baseUrl = envModule === 'development' ? 'https://ind.test.geetecho.com' : 'https://ind.geetecho.com'
    // that.baseUrl = envModule === 'development' ? 'http://localhost:3000' : 'https://ind.geetecho.com'

    that.getData()
  }
}
</script>

<style>
body {background: #fff}
</style>
<style scoped>
.client {padding: 30px 28px}

.stage_nav {margin: 20px 0 0 0;background-color: #F8F8F9;border-top: 1px solid #EBEBEB;border-bottom: 1px solid #EBEBEB;}
.stage_nav_con {justify-content: flex-start}
.stage_nav_info {line-height: 50px;font-size: 14px;color: #666}

.client_header_con {display: flex;justify-content: space-between}
.client_header_l {color: #303030;font-size: 24px;font-weight: bold}
.client_header_date {margin: 0 16px}
.client_header_date input {border: 1px solid #DBDBDB;border-radius: 4px;height: 32px;width: 200px;outline: none;padding: 0 15px;font-size: 14px}
.client_header_btn button {width: 80px;height: 32px;background: #4C8BFF;border-radius: 4px;outline: none;border: 1px solid #4C8BFF;font-size: 12px;color: #FFFFFF}
.stage_nav_con .stage_nav_info,
.user_total_val {width: 180px}
.stage_nav_con .stage_nav_info:nth-of-type(1) {width: 160px}
.user_total_val {display: flex;align-items: center}

.user_info {display: flex}
.user_name {width: 200px}
.user_name span {font-size: 14px;font-weight: bold;color: #282828;line-height: 46px}
.user_main {width: 100%;height: 80vh;overflow: auto}
.user_container {border-bottom: 1px solid #EBEBEB;overflow: hidden}
.user_container:hover {background-color: #eee}
.user_session_header_con {display: flex;margin-left: 38px;padding-left: 34px;background-color: #F8F8F9}
.user_session_header_info, .user_session_main_info {min-width: 200px;max-width: 200px;height: 50px;display: flex;align-items: center}
.user_session_header_info.user_session_info_remark, .user_session_main_info.user_session_info_remark {min-width: 240px;max-width: 240px}
.user_session_con {background-color: #F8F8F9}
.user_session_main {margin-left: 38px;padding-left: 17px;background-color: #FFF}
.user_session_main_info_con {display: flex;align-items: center;line-height: 32px;padding-left: 17px;width: 100%;border-bottom: 1px solid #EBEBEB}
.user_session_main_info_con:hover {background-color: #E9F1FF}
.user_session_main_info span {font-size: 14px;font-weight: 400;color: #282828}
.user_session_info_remark {padding: 0 10px}
.user_session_main_info_status {display: flex;align-items: center;position: relative;padding-left: 14px}
.user_session_main_info_status::before {position: absolute;content: '';display: block;width: 8px;height: 8px;border-radius: 50%;left: 0;top: 50%;transform: translateY(-50%)}
.user_session_main_info_tag_success::before {background-color: #12BF26}
.user_session_main_info_tag_planning::before {background-color: #4C8BFF}

.user_session_main_info_select,
.user_session_stage_select {background-color: rgba(18, 191, 38, .1)}
</style>



// WEBPACK FOOTER //
// src/components/page-inquire/index.vue